import { AfterContentInit, ChangeDetectionStrategy, Component, Input, OnDestroy, TemplateRef } from '@angular/core';
import { fromEvent, Observable, Subject } from 'rxjs';
import { distinctUntilChanged, map, takeUntil } from 'rxjs/operators';

export interface IBreadcrumbItem {
  title: string;
  link?: string;
}

@Component({
  selector: 'app-breadcrumb',
  templateUrl: 'breadcrumb.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnDestroy, AfterContentInit {
  @Input()
  public title: string;

  @Input()
  public items: IBreadcrumbItem[] | null;

  @Input()
  public withFilter: boolean = false;

  @Input()
  public beforeTitleTemplate?: TemplateRef<{}>;

  @Input()
  public isLoading?: boolean = false;

  public stuck$: Observable<boolean>;

  private destroy$: Subject<void> = new Subject();

  public ngAfterContentInit(): void {
    this.stuck$ = fromEvent(window, 'scroll')
      .pipe(takeUntil(this.destroy$))
      .pipe(map(() => window.scrollY > 28))
      .pipe(distinctUntilChanged());
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
